<template>
	<div>
		<el-dialog :visible.sync="showOpinion" width="527" center :show-close="true" title="服务据点">
			<div class="dialog">
				<div style="height: 500px;overflow-y: scroll;">
					<div class="wbox" v-for="(item,index) in list">
						<div class="tit">{{item.name}}</div>
						<div class="tit2 flex">
							<img src="../../src/assets/images/home/call.png"
								style="width: 18px;height: 18px;margin-right: 6px;" alt="" />
							{{item.phone}}
						</div>
						<div class="tit2 flex">
							<img src="../../src/assets/images/home/address.png"
								style="width: 18px;height: 18px;margin-right: 6px;" alt="" />
							{{item.address}}
						</div>
					</div>
				</div>

			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getService
	} from "@/api/common";
	export default {
		data() {
			return {
				showOpinion: false,
				list:[]
			}
		},
		mounted() {
			this.getService()
		},
		methods: {
			async getService() {
				const {
					status,data
				} = await getService({})
				this.list=data.result.data
			},
			openDialog() {
				this.showOpinion = true
			},
		}
	}
</script>

<style lang="less" scoped>
	.wbox {
		background: #FFFFFF;
		box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
		border-radius: 13px 13px 13px 13px;
		padding: 16px;
		margin-bottom: 6px;

		.tit {
			margin-bottom: 6px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #000000;
		}

		.tit2 {
			padding: 3px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
		}
	}

	.login-btn {
		width: 100%;
		height: 59px;
		background: url('../assets/images/login/loginbtn.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 13px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.dialogFeed {
		.navs {
			.navItem {
				width: 48%;
				height: 40px;
				background: #FFFFFF;
				border-radius: 13px 13px 13px 13px;
				border: 1px solid #EEEEEE;
				opacity: 0.8;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
			}

			.active {
				background: rgba(0, 167, 60, 0.06);
				border-radius: 13px 13px 13px 13px;
				color: #00A73C;
			}
		}

		.opinion {
			margin: 10px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #000000;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #FC5F5F;
			}
		}

		input {
			width: 100%;
			padding: 0 20px;
			height: 44px;
			background: #F7F8F9;
			border-radius: 11px 11px 11px 11px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #000;
			line-height: 44px;
			border: none;

			&:focus {
				outline: none;
			}
		}

		.t {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #666666;
		}

		.img {
			width: 136px;
			height: 136px;
			background: #F8F8FA;
			border-radius: 9px 9px 9px 9px;
		}

		.rel {
			position: relative;

			.delect {
				position: absolute;
				top: -6px;
				right: -6px;
			}
		}

		.wbox {
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 16px;
			margin-bottom: 6px;

			.tit {
				margin-bottom: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 18px;
				color: #000000;
			}

			.tit2 {
				padding: 3px 0;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
			}
		}
	}

	::v-deep .el-dialog__header {
		padding: 20px 20px 10px !important;
	}

	::v-deep .el-dialog__body {
		padding: 25px 25px 30px !important;
	}

	::v-deep .el-dialog__close:hover {
		color: #999;
	}

	::v-deep .el-dialog__headerbtn {
		font-size: 24px;
	}
</style>